/**
 * Current API version number
 */
export const API_VERSION = 1;

/**
 * Base API prefix including version
 */
export const API_BASE = `/api/v${API_VERSION}`;
